import React, { useState } from "react";
import { LangLoader, FormattedMessage } from "@irati/utils/lang";
import History from "@irati/utils/history";
import { ONBOARDING } from "@irati-web/app/src/routeConfig";
import onboardingService from "@irati/onboarding/services/onboarding";
import { UserTracking as tracking } from "@irati-tracking/onboarding";
import OnboardingSteps from "@irati/onboarding/enums/Step";
import Modal from "@irati/ui/src/GenericModal";
import { H3, Body } from "@irati/ui/src/Typography";
import image from "@irati/ui/images/welcomeUserOnboarding.svg";
var SetDetailsModal = function (_a) {
    var user = _a.user;
    var _b = useState(null), submit = _b[0], setSubmit = _b[1];
    var close = function () {
        tracking.welcomePopUpDismissed();
        var load = onboardingService.completeStep(user, OnboardingSteps.SET_DETAILS);
        setSubmit(load);
        return load;
    };
    var setDetails = function () {
        tracking.welcomePopUpGoToProfile();
        close().then(function () {
            History.push("/account/profile");
        });
    };
    if (!user)
        return null;
    return (React.createElement(LangLoader, { bucket: ONBOARDING },
        React.createElement(Modal, { show: true, image: image, load: submit, onHide: close, onConfirm: setDetails, dismissButtonText: "onboarding.setDetailsModal.close", proceedButtonText: "onboarding.setDetailsModal.continue" },
            React.createElement(H3, null,
                React.createElement(FormattedMessage, { id: "onboarding.setDetailsModal.header" })),
            React.createElement(Body, { marginTop: 1, marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "onboarding.setDetailsModal.content" })))));
};
export default SetDetailsModal;
